import { useCallback } from 'react';
import { useCreateImages } from '@tribeplatform/react-sdk/hooks';
import { setNodeAttrById } from '../helpers/node';
import { getFileReader } from '../utils/filereader';
export const useAddImageToEditor = () => {
    const { mutateAsync: createImages } = useCreateImages();
    const addImage = useCallback(async (view, file, attrs) => {
        const fileSrc = await getFileReader(file);
        const nodeType = view.state.schema.nodes['async-image'];
        const node = nodeType.create({
            ...attrs,
            id: file.id,
            src: fileSrc.url,
            loading: true,
        });
        const { head } = view.state.selection;
        const transaction = view.state.tr.insert(head, node);
        view.dispatch(transaction);
        const [{ url, id }] = await createImages([{ file }]);
        setNodeAttrById(view, nodeType, file.id, { id, src: url, loading: false });
    }, [createImages]);
    return {
        addImage,
    };
};
//# sourceMappingURL=useAddImageToEditor.js.map